import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TokenService } from '../../../../service/token.service';
import { GateInService } from '../../../../service/gate-in/gate-in.service';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { VendorTsService } from '../../../../service/vendor/vendor.ts.service';

interface TokenItem {
  token_no: any;
}
interface POItem {
  poNumber: string;
  details: string;
  items: Item[];
}
interface Item {
  poagreement_no: string;
  item_no: string;
  material_code: string;
  description: string;
  quantity: number;
  received_qty: number;
  uom: string
}

@Component({
  selector: 'app-gate-in',
  templateUrl: './gate-in.component.html',
  styleUrls: ['./gate-in.component.scss']
})
export class GateInComponent implements OnInit {
  vendor_list: any[] = []
  gate_list: any[] = []
  poList: any[] = [];
  gateInDataList: any[] = [];
  showAccordion: boolean = false;
  read: boolean = true;
  recordDetails = {
    poNumber: '',
    agNumber: '',
    gateNumber: '',

    poAccordions: [] as POItem[],

  };
  poDetails = {
    poNumber: '',
  };

  gateDetails = {
    gateNumber: '',
  };



  gatedetails!: FormGroup;
  createGateInForm!: FormGroup;
  purpose = ["Loading", "Unloading"];
  products!: any[];
  gate!: string
  token_no_list: TokenItem[] = [];
  all_po_list: any[] = [];
  selected_po: any[] = [];
  token: any;
  constructor(
    private formBuilder: FormBuilder,
    private tokenService: TokenService,
    private gateInService: GateInService,
    public messageService: MessageService,
    private datePipe: DatePipe,
    private vendorService: VendorTsService
  ) { }

  ngOnInit(): void {
    this.createGateInForm = this.formBuilder.group({
      plant: ['', Validators.required],
      gate: ['', Validators.required],
      purpose: ['', Validators.required],
      remark_1: [''],
      remark_2: [''],
      invoice: [''],
      driver: [''],
      driver_mobile_no: [''],
      vehicle: [''],
      net_value: [''],
      e_way_bill_no: [''],
      total_invoice_value: [''],
      origin_of_country: [''],
      created_by: [''],
      created_on: [''],
      received_by: [''],
      docket_date: [''],
      docket_no: [''],
      loading_unloading_point: [''],
      boe_no: [''],
      boe_date: [''],
      total_net_weight: [''],
      total_gross_weight: [''],
      test: [''],
      invoice_date: [''],
      gate_number: [''],
      packing_type: [''],
      number_of_packages: [''],
      formArray: this.formBuilder.array([])
    });

    this.getAllTokenNo()
    this.getUserDetail()
    this.getVendorList()
    this.getPlantGateDetail()
  }

  onMultiSelectChange(event: any) {
    this.selected_po = event.value;
  }

  get formArray() {
    return this.createGateInForm.get('formArray') as FormArray;
  }


  patchValues() {
    this.gate_list[0].PoList.forEach((obj: any) => {
      const formGroup = this.formBuilder.group({
        poagreement_no: [''],
        company_code: [''],
        company_name: [''],
        doc_cat: [''],
        doc_type: [''],
        vendor_code: [''],
        vendor_name: [''],
        purpose: [''],
        plant: [''],
        gate: [''],
        remark_1: [''],
        remark_2: [''],
        plant_code: [''],
        plant_name: [''],

        gate_number: [''],
        invoice_challan_no: [''],
        invoice_date: [''],
        driver_name: [''],
        driver_mobile_no: [''],
        vehicle_no: [''],
        packing_type: [''],
        total_net_weight: [''],
        total_gross_weight: [''],

        number_of_packages: [''],
        net_value: [''],
      });
      formGroup.get('poagreement_no')?.setValue(obj.poagreement_no);
      formGroup.get('company_code')?.setValue(obj.company_code);
      formGroup.get('company_name')?.setValue(obj.name1);
      formGroup.get('doc_cat')?.setValue(obj.doc_cat);
      formGroup.get('doc_type')?.setValue(obj.doc_type);
      formGroup.get('vendor_name')?.setValue(obj.vendor);
      formGroup.get('vendor_code')?.setValue(obj.vendor_code);
      formGroup.get('net_value')?.setValue(obj.net_value);

      formGroup.get('plant_code')?.setValue(this.gate_list[0].plant_code);
      formGroup.get('plant_name')?.setValue(this.gate_list[0].plant_name);

      formGroup.get('gate_number')?.setValue(this.gate_list[0].gate_no);
      formGroup.get('invoice_challan_no')?.setValue(this.gate_list[0].invoice);
      formGroup.get('invoice_date')?.setValue(this.gate_list[0].invoice_date);
      formGroup.get('packing_type')?.setValue(this.gate_list[0].packing_type);
      formGroup.get('total_net_weight')?.setValue(this.gate_list[0].total_net_weight);
      formGroup.get('total_gross_weight')?.setValue(this.gate_list[0].total_gross_weight);
      formGroup.get('number_of_packages')?.setValue(this.gate_list[0].no_of_packages);


      this.formArray.push(formGroup);

    })
  }

  onSubmit() {
    if (this.createGateInForm.valid) {
      const formattedDate = this.datePipe.transform(this.createGateInForm.get('docket_date')?.value, 'yyyy-MM-dd')
      const formattedDateBoe = this.datePipe.transform(this.createGateInForm.get('boe_date')?.value, 'yyyy-MM-dd')
      const formData = this.createGateInForm.value;
      formData.docket_date = formattedDate;
      formData.boe_date = formattedDateBoe
      const formArrayValues = this.formArray.controls.map(control => control.value);
      const payload = {
        data: {
          ...formData,
          gateEntries: formArrayValues
        }
      };

      this.gateInService.createGateIN(payload).then((_response) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Data submitted successfully!' });
        this.createGateInForm.reset();
        this.formArray.clear();
        this.getPlantGateDetail()
      }).catch((error) => {
        console.error('Submission error:', error);
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Submission failed. Please try again.' });
      });

    } else {
      this.createGateInForm.markAllAsTouched();
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill in all required fields correctly.' });
    }
  }

  getselectedVendorPoList(business_name: any) {
    this.selected_po = []
    this.all_po_list = []
    this.tokenService.getselectedVendorPoList(business_name).then((res) => {
      res.message.forEach((element: any) => {
        this.all_po_list.push(element.po)
      });
    }).catch((error) => {
      console.log(error);
    });
  }
  getVendorList() {
    this.tokenService.getVendorList().then((res) => {
      res.message.forEach((element: any) => {
        this.vendor_list.push(element.business_name)
      });
    }).catch((error) => {
      console.log(error);
    });
  }
  getAllTokenNo() {
    this.tokenService.getAllTokenNo().then((res) => {
      this.token_no_list = res.message.token_no_with_value as TokenItem[];
    }).catch((error) => {
      console.log(error);
    });
  }

  async getPlantGateDetail() {
    try {
      const isVendor = await this.vendorService.checkIfVendor();
      if (isVendor.message.isGateKeeper) {
        const response = await this.vendorService.getGateAndPlantDetail();
        this.createGateInForm.patchValue({
          plant: response.message.plant_detail[0]?.name,
          gate: response.message.gate_detail[0]?.name
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  onTokenNoSelected(selectedValue: any) {
    if (!selectedValue) {
      this.clearFormArray();
      this.showAccordion = false;
      this.recordDetails.poAccordions = [];
      this.createGateInForm.reset();
      this.getPlantGateDetail()
      return;
    }
    this.clearFormArray();
    this.gateInService.getAllGateInData(selectedValue).then((res) => {
      this.gate_list = res.message
      this.showAccordion = res.message && res.message.length > 0;
      this.patchValues()
      this.recordDetails.poAccordions = [];
      this.createGateInForm.get('gate_number')?.setValue(res.message[0].gate_no)
      this.createGateInForm.get('purpose')?.setValue(res.message[0].purpose)
      this.createGateInForm.get('driver')?.setValue(res.message[0].driver_name)
      this.createGateInForm.get('driver_mobile_no')?.setValue(res.message[0].driver_mobile_no)
      this.createGateInForm.get('vehicle')?.setValue(res.message[0].vehicle_no)
      this.createGateInForm.get('packing_type')?.setValue(res.message[0].packing_type)
      this.createGateInForm.get('total_net_weight')?.setValue(res.message[0].total_net_weight)
      this.createGateInForm.get('total_gross_weight')?.setValue(res.message[0].total_gross_weight)
      this.createGateInForm.get('test')?.setValue(res.message[0].PoList[0].vendor_code)
      this.createGateInForm.get('invoice')?.setValue(res.message[0].invoice);
      const formattedDate = this.datePipe.transform(this.gate_list[0].invoice_date, 'dd/MM/yyyy');
      this.createGateInForm.get('invoice_date')?.setValue(formattedDate);
      this.createGateInForm.get('loading_unloading_point')?.setValue(res.message[0].loading_unloading_point);
      const gateData = res.message[0];
      this.recordDetails.poAccordions = gateData.PoList.map((po: any) => ({
        items: po.itemList.map((item: Item) => ({
          poNumber: po.poagreement_no,
          itemNo: item.item_no,
          materialCode: item.material_code,
          materialDescription: item.description,
          poQty: item.quantity,
          receivedQty: item.received_qty,
          uom: item.uom,
        }))
      }));
    }).catch((error) => {
      console.log(error);
      this.showAccordion = false;
      this.recordDetails.poAccordions = [];

    });
  }


  getUserDetail() {
    this.gateInService.getUserDetail().then((res) => {
    }).catch((error) => {
      console.log(error)
    })
  }

  clearFormArray() {
    while (this.formArray.length !== 0) {
      this.formArray.removeAt(0);
    }
  }

}
